var _rect, _rect2, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAddText(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.25,
    y: 6.25,
    width: 27.5,
    height: 27.5,
    rx: 2.08333,
    stroke: "black",
    strokeWidth: 2.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 6.25,
    y: 6.25,
    width: 27.5,
    height: 27.5,
    rx: 2.08333,
    stroke: "white",
    strokeOpacity: 0.7,
    strokeWidth: 2.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1668 14.1976C13.7066 14.1976 13.3335 13.8245 13.3335 13.3642V12.5C13.3335 12.0397 13.7066 11.6666 14.1668 11.6666H25.8335C26.2937 11.6666 26.6668 12.0397 26.6668 12.5V13.3642C26.6668 13.8245 26.2937 14.1976 25.8335 14.1976H22.3349C21.8747 14.1976 21.5016 14.5706 21.5016 15.0309V27.5C21.5016 27.9602 21.1285 28.3333 20.6683 28.3333H19.3321C18.8718 28.3333 18.4987 27.9602 18.4987 27.5V15.0309C18.4987 14.5706 18.1256 14.1976 17.6654 14.1976H14.1668Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1668 14.1976C13.7066 14.1976 13.3335 13.8245 13.3335 13.3642V12.5C13.3335 12.0397 13.7066 11.6666 14.1668 11.6666H25.8335C26.2937 11.6666 26.6668 12.0397 26.6668 12.5V13.3642C26.6668 13.8245 26.2937 14.1976 25.8335 14.1976H22.3349C21.8747 14.1976 21.5016 14.5706 21.5016 15.0309V27.5C21.5016 27.9602 21.1285 28.3333 20.6683 28.3333H19.3321C18.8718 28.3333 18.4987 27.9602 18.4987 27.5V15.0309C18.4987 14.5706 18.1256 14.1976 17.6654 14.1976H14.1668Z",
    fill: "white",
    fillOpacity: 0.7
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddText);
export default __webpack_public_path__ + "static/media/add_text.764441607fbbd6a97c506f37345727af.svg";
export { ForwardRef as ReactComponent };